import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../services/authService';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await forgotPassword(email);
      setMessage('Eğer bu adrese kayıtlı bir hesap varsa şifre sıfırlama linki gönderildi.');
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Şifremi Unuttum</h2>
        <p style={styles.description}>
          Email adresinizi girin, şifre sıfırlama linkini gönderelim.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          {message && <p style={styles.success}>{message}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Link Gönder'}
          </button>
        </form>
        <p style={styles.backLink}>
          <span style={styles.link} onClick={() => navigate('/login')}>
            ← Giriş sayfasına dön
          </span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    width: '360px',
  },
  title: {
    textAlign: 'center',
    marginBottom: '8px',
    color: '#1a1a2e',
  },
  description: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '24px',
  },
  field: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  input: {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    fontSize: '14px',
  },
  error: {
    color: 'red',
    fontSize: '13px',
    marginBottom: '8px',
  },
  success: {
    color: 'green',
    fontSize: '13px',
    marginBottom: '8px',
  },
  button: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#1a1a2e',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '16px',
    fontSize: '13px',
  },
  link: {
    color: '#1a1a2e',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

export default ForgotPasswordPage;